
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqOdnhf3IIepHmM9b6J6xKZb_45U5iouclmvajpu_3R42v8Meta } from "/codebuild/output/src2452713992/src/src/pages/faq.vue?macro=true";
import { default as menu_456_45_40dF5XWec5z4mtDCXiaZTbBvmjPDoLeRGQ4KspcMeta } from "/codebuild/output/src2452713992/src/src/pages/menu.vue?macro=true";
import { default as indexv_hj1N7ukr3j6_x3cMoGm7bamxx_pHOn40d_wKnIe80Meta } from "/codebuild/output/src2452713992/src/src/pages/index.vue?macro=true";
import { default as contactqdyT7ffC88U0ndbEBr2BY_aPgMjkne53EvScpd0t1wUMeta } from "/codebuild/output/src2452713992/src/src/pages/contact.vue?macro=true";
import { default as tutorialIF2tI3VXFpNVdGf2LwxOZ64qOmKMxKAXm0YhxlexenAMeta } from "/codebuild/output/src2452713992/src/src/pages/tutorial.vue?macro=true";
import { default as agreementuT_459Uy94N9g3apfbrCJZREWjtPkXnGmUsotwBaxdgtYMeta } from "/codebuild/output/src2452713992/src/src/pages/agreement.vue?macro=true";
import { default as about_45passU_CEBuPJ_4lWalW6Leyx0tPbnLegozIDXcGfa1BL6WwMeta } from "/codebuild/output/src2452713992/src/src/pages/about-pass.vue?macro=true";
import { default as indexBivGBQXMZZLffgF5I8qvi484oaeqa8N19H2En7sEDw8Meta } from "/codebuild/output/src2452713992/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93uljIno9zJGrCacy0GuQLlNhrZAXrUh4c7dt_Jn7XPX8Meta } from "/codebuild/output/src2452713992/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceyws8EqppLgrxlpdD8cIYAOeDNGr6BFei9FsG67wT5wwMeta } from "/codebuild/output/src2452713992/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93RnL5SJp_45TncT1CJYvWOlgidttREOPQhpeGGNlQ_B3LUMeta } from "/codebuild/output/src2452713992/src/src/pages/notice/[id].vue?macro=true";
import { default as indexvaTOZCOC_45rG2dz_2t56RmQ58UJhM_D5ikriYCRBmgqgMeta } from "/codebuild/output/src2452713992/src/src/pages/coupon/index.vue?macro=true";
import { default as index6oee_rznhnDIyCTk6fPtHjW0PVPJLL7TF7U31VhylScMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/index.vue?macro=true";
import { default as indexw9aChRVx0tN7Miw7WD0EKOQnnL70kRKsq42668M9YYMMeta } from "/codebuild/output/src2452713992/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93C6fRiMCj8Gdv7cY3zTR_c3yE3x8PVYOZXT5tAnSsdbkMeta } from "/codebuild/output/src2452713992/src/src/pages/parking/[id].vue?macro=true";
import { default as indexIY8lVujpRZBa9b_wZ1hcBy0cc7xcKbnDGfR1eDtCUrUMeta } from "/codebuild/output/src2452713992/src/src/pages/history/index.vue?macro=true";
import { default as indexqpDSW_45cWYkwkdAUHERL_450_45zbKr2w_458_tb12Xovdkb9sMeta } from "/codebuild/output/src2452713992/src/src/pages/monthly/index.vue?macro=true";
import { default as indexGB7OEDI1VTAZ0kAAFYrHJidJmPDduzVjA9FJuVqxrxAMeta } from "/codebuild/output/src2452713992/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexMhJiXg0VSY7cp7Qd_45_45OZKeLrW3Az1bSMr48kwWoUZ5kMeta } from "/codebuild/output/src2452713992/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavivpBni5YdHn41w8XmPJvES50uLwyAQhNfZGDrluuFHxoMeta } from "/codebuild/output/src2452713992/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit_45LvGpJjfHc4q5A5UHYzKDWQ0CyTWxjrv7h7hyTJ2xFQMeta } from "/codebuild/output/src2452713992/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementlAusn8cWvoPrTt9rRs4mrKs6bS5tf8qCGAuTs_6d8mgMeta } from "/codebuild/output/src2452713992/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexRcMu1FJBomhFntFwXzjr9Rx_45s3_45ZOpsFwcF7obHXKuUMeta } from "/codebuild/output/src2452713992/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dnEdflkaDPP_uYWCEoAgZuS8uIk_CNdfh7O4rWpUzcvUMeta } from "/codebuild/output/src2452713992/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmRB4I5WCZ7JsSzdicYf8OjXIrzA31MMMUIrWWx1S5_45M8Meta } from "/codebuild/output/src2452713992/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index1GwXcY0OlE5TAEOLIo6s_45NXoF_457mLufMmtsRGrNl1bAMeta } from "/codebuild/output/src2452713992/src/src/pages/card/create/index.vue?macro=true";
import { default as indexXiQv9hKZ29J01UzvbU5_zlDfoZzpAsWyaETi5c_rIjsMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmgKajDAlp5zW9IFSwggImsBwkkV4z4dE0SRqRTRiKoiwMeta } from "/codebuild/output/src2452713992/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmAYio4Ofzwy1ybO4LoWLzytiuH1fhrrsrW7YHO44VJVQMeta } from "/codebuild/output/src2452713992/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completee_bhNGkqaFwbg420t8N3ejNb9HHkHpTtl4uCyJp7lQIMeta } from "/codebuild/output/src2452713992/src/src/pages/membership/complete.vue?macro=true";
import { default as register8Ma9ONWVSwunyT0j8N1n_VyqTe0_qfm4PJzi3ZYS0GsMeta } from "/codebuild/output/src2452713992/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93DRzv8_45vWI_45qHjUJejb_NwwAeW20piAUoGrpP8ZI185UMeta } from "/codebuild/output/src2452713992/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmaFfhihO4pXWT9cOt2VB23HNErjtjZXQF_S3FPh5qaIMMeta } from "/codebuild/output/src2452713992/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93smrueBRKe7Tk3jXE85ev_c8O_a2j1scu6lA1s9cvIKYMeta } from "/codebuild/output/src2452713992/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexGufygSligWwROdvL0yL1MtPmv4P_45KFoEZ_K3Tjb9C8EMeta } from "/codebuild/output/src2452713992/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codedmGvqsJS1Rs44pufI25WJXDnCljgYfnKOHtBUUtlUS0Meta } from "/codebuild/output/src2452713992/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codegS_45FJK0h22XyoHniMOpKI_x8fGpAj_452Q1sZdeRtCmhsMeta } from "/codebuild/output/src2452713992/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completekGTBAKbn2XX5DFmWtRU7Y5QDiSOa3hepw4EGuay7MWEMeta } from "/codebuild/output/src2452713992/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerq8umgeVlS7_45oLTj_45gn_450UZRw4_I5A2GylflJ2YI8SSsMeta } from "/codebuild/output/src2452713992/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeSGe1C9o1UM_TIkBJ3aLiS08czl3ahdP9VryUldKEUc4Meta } from "/codebuild/output/src2452713992/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexBnJjo4aWxMPl6tnU9RQQocdEfIHa7afg7z_V8gCYcNoMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmJ8FetlDSvgPToKJI0pjakaCT1ti5h9uo1TMx711_45rsIMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeMRysMjP_jnZZ0_45vDQ0_45NV2KmgxH7o1mmtVQYFc9jvBIMeta } from "/codebuild/output/src2452713992/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexvjYO2_TQe_pX01ome3Y5tTNBKWeJ48wdisMCc488vioMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_937_4U1iLCPIatiCnyrLi4MJUUkeJWAfyCtyiGAFiLNBwMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeNfRUW_zkNZQaw8MfeBZclIOSCWAMknkFtE6P_TsBbhQMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasvWas10qPchO1qZYGlMiYvSD7zUg3za6DCbPK6Uh_45vYMMeta } from "/codebuild/output/src2452713992/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleW26vsRte3n_45nrtLXMEHtofhB526F1ZOXofi_45SMsUH8wMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailG9YQG3hEK5JdZsDkjVmibQK5R8Uf9xbrtcWPrwKiABUMeta } from "/codebuild/output/src2452713992/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm8tLXgHqvaZp43_utap9mIKNnNvxg6EOnStwViJyj7n0Meta } from "/codebuild/output/src2452713992/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent1YLYgZ6Ze1NHNdYPnn1n0edl9qAbm6aVq89IURDiMSgMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmgVQ85I3nW4x1piz4ZMkAo0iya3D5AGfiKnJ3Mv6CDV8Meta } from "/codebuild/output/src2452713992/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedates5tbkHnc_45rM_30huq_QAa54iDLgPGPvh_iberHiejdUMeta } from "/codebuild/output/src2452713992/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeU_Ceops6YFxdeCHg3IQLr7w33ElEuLt9DnUgVrx6ua4Meta } from "/codebuild/output/src2452713992/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeOYfaCwG1dvO7ONTYmserNJYwDG92bddwbpuUDkXR_HsMeta } from "/codebuild/output/src2452713992/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordEphAfujubFuWW3eVS9ymn_F1V_45HrSKkd5pa81tEtkeAMeta } from "/codebuild/output/src2452713992/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliashIMJE0Hm_l5mLWpbq7cslhcoy9VAdEzgPiHJDcUt2wQMeta } from "/codebuild/output/src2452713992/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registernf3iHvIZJYeeZZm96O_45C1ZL4wfb8PD64baCMQtBR3swMeta } from "/codebuild/output/src2452713992/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code99OkbaIxGQi3jRcAQSI51IWEQYsqwi_453Ynuf4A1ESlIMeta } from "/codebuild/output/src2452713992/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexclKkJaKoT_N0fcRfjogjjmMKpSQqiEPydi5mU0fcWcMMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexgGTEeXYPPtnTR1rSRhl_45bbWXH3oMVnnKKKuxoev63Y4Meta } from "/codebuild/output/src2452713992/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexD6SPNK4nBVIlL_1nLkyH8V9OpMzuX2lvZjVjjtTNkZ8Meta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexuIvvo34TvS7dw7BuVxpdn9r8UlgLODlrcvODGyUQl9wMeta } from "/codebuild/output/src2452713992/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatex_45JIhZxLGOSIGtyzhGJ9H0ylLONWwDgP27JHh8jIctoMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as complete_45o86b4fLeElvOrk7WKbk5zys1pGBr7vT4ltWEIJnV2YMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmw16Mho6F3pj4EgjjC_NslshMG0EKDo_459zlE1lKpD_45bEMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexelpdjrODFVJZeISOgznnJGnV76YyASZ1MiINN3crRpYMeta } from "/codebuild/output/src2452713992/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeuwwTtuCaUNfZlB75JyiIlLO_Xn5IRofKgglF3LdB7sMMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatemBooN34hEpyWQvxhpjA2uYilO7RL8iKwxnLuSPpz1VAMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexx_45_45teH_45eCICgM9gbNwNRz89ofppESn6ZpSWdvBUqg48Meta } from "/codebuild/output/src2452713992/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexJS9JeObVQ9A35gNf2pX2s2wLXQWRpvmZIMY8FYitf_45EMeta } from "/codebuild/output/src2452713992/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeKnV_7nw8Znybj_DNWTqhDo7bq_hdQAJ5FJvZvmj4ZDYMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexozPYy_mD6zPUy99wke0YrNILNf_djMJTMl0oRq6lZ8EMeta } from "/codebuild/output/src2452713992/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeZNiOVjLKiEANjA_45nRSJtudNhNoaJIY3AlsgZGj_45hOoYMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexUArqLjxs2BHiSSb_IsLVWUe_logMsngbpZrJGPC4RZwMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexbFHVvMNdDMZ8NZ4L8rc4Px9ZnyIyGQMAx9lEhOnI5ccMeta } from "/codebuild/output/src2452713992/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexGcTJhQRzfeFv90q0QyP5Vln_ZqoVYkU59D9bcocSy8AMeta } from "/codebuild/output/src2452713992/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update0DocFRc1rJTh_45V1fFsCOf96nftt3hESsucVwq22aa7cMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmOG1Hvwxy27W7pm5lv6sGxvqOZcfz8fb1qzO_45kU_wwvoMeta } from "/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu_456_45_40dF5XWec5z4mtDCXiaZTbBvmjPDoLeRGQ4KspcMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexv_hj1N7ukr3j6_x3cMoGm7bamxx_pHOn40d_wKnIe80Meta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexvaTOZCOC_45rG2dz_2t56RmQ58UJhM_D5ikriYCRBmgqgMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2452713992/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexIY8lVujpRZBa9b_wZ1hcBy0cc7xcKbnDGfR1eDtCUrUMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2452713992/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexGB7OEDI1VTAZ0kAAFYrHJidJmPDduzVjA9FJuVqxrxAMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexMhJiXg0VSY7cp7Qd_45_45OZKeLrW3Az1bSMr48kwWoUZ5kMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index1GwXcY0OlE5TAEOLIo6s_45NXoF_457mLufMmtsRGrNl1bAMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmgKajDAlp5zW9IFSwggImsBwkkV4z4dE0SRqRTRiKoiwMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmAYio4Ofzwy1ybO4LoWLzytiuH1fhrrsrW7YHO44VJVQMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2452713992/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completee_bhNGkqaFwbg420t8N3ejNb9HHkHpTtl4uCyJp7lQIMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: register8Ma9ONWVSwunyT0j8N1n_VyqTe0_qfm4PJzi3ZYS0GsMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmaFfhihO4pXWT9cOt2VB23HNErjtjZXQF_S3FPh5qaIMMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codedmGvqsJS1Rs44pufI25WJXDnCljgYfnKOHtBUUtlUS0Meta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codegS_45FJK0h22XyoHniMOpKI_x8fGpAj_452Q1sZdeRtCmhsMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completekGTBAKbn2XX5DFmWtRU7Y5QDiSOa3hepw4EGuay7MWEMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerq8umgeVlS7_45oLTj_45gn_450UZRw4_I5A2GylflJ2YI8SSsMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmJ8FetlDSvgPToKJI0pjakaCT1ti5h9uo1TMx711_45rsIMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeMRysMjP_jnZZ0_45vDQ0_45NV2KmgxH7o1mmtVQYFc9jvBIMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexvjYO2_TQe_pX01ome3Y5tTNBKWeJ48wdisMCc488vioMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeNfRUW_zkNZQaw8MfeBZclIOSCWAMknkFtE6P_TsBbhQMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleW26vsRte3n_45nrtLXMEHtofhB526F1ZOXofi_45SMsUH8wMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailG9YQG3hEK5JdZsDkjVmibQK5R8Uf9xbrtcWPrwKiABUMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm8tLXgHqvaZp43_utap9mIKNnNvxg6EOnStwViJyj7n0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent1YLYgZ6Ze1NHNdYPnn1n0edl9qAbm6aVq89IURDiMSgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmgVQ85I3nW4x1piz4ZMkAo0iya3D5AGfiKnJ3Mv6CDV8Meta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeU_Ceops6YFxdeCHg3IQLr7w33ElEuLt9DnUgVrx6ua4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeOYfaCwG1dvO7ONTYmserNJYwDG92bddwbpuUDkXR_HsMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordEphAfujubFuWW3eVS9ymn_F1V_45HrSKkd5pa81tEtkeAMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registernf3iHvIZJYeeZZm96O_45C1ZL4wfb8PD64baCMQtBR3swMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code99OkbaIxGQi3jRcAQSI51IWEQYsqwi_453Ynuf4A1ESlIMeta || {},
    component: () => import("/codebuild/output/src2452713992/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2452713992/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]